import { Plus } from "lucide-react";
import { Button } from "../../../../components/ui/common/button";

interface UserListHeaderProps {
  onRegisterClick: () => void;
}

/** Page heading + "Add new user" action, styled after `CompanyListHeader`. */
const UserListHeader = ({ onRegisterClick }: UserListHeaderProps) => (
  <div className="tw-mb-6 tw-flex tw-items-center tw-justify-between tw-gap-4">
    <div>
      <h1 className="tw-font-display tw-text-2xl tw-font-bold tw-text-foreground">Users</h1>
      <p className="tw-mt-1 tw-text-sm tw-text-muted-foreground">
        Registered users, their contact details and the role that controls their access
      </p>
    </div>
    <Button onClick={onRegisterClick} className="tw-shrink-0 tw-gap-2">
      <Plus className="tw-h-4 tw-w-4" />
      Add new user
    </Button>
  </div>
);

export default UserListHeader;
